module.exports = __webpack_public_path__ + "static/media/mitsubishi-thumbs.98de78ec.svg";